export const GET_SALE_ITEM_REQUEST = 'GET_SALE_ITEM_REQUEST'
export const GET_SALE_ITEM_SUCCESS = 'GET_SALE_ITEM_SUCCESS'
export const GET_SALE_ITEM_FAIL = 'GET_SALE_ITEM_FAIL'
export const GET_SALE_ITEM_RESET = 'GET_SALE_ITEM_RESET'

export const ADD_SALE_ITEM_REQUEST = 'ADD_SALE_ITEM_REQUEST'
export const ADD_SALE_ITEM_SUCCESS = 'ADD_SALE_ITEM_SUCCESS'
export const ADD_SALE_ITEM_FAIL = 'ADD_SALE_ITEM_FAIL'

export const REMOVE_SALE_ITEM_REQUEST = 'REMOVE_SALE_ITEM_REQUEST'
export const REMOVE_SALE_ITEM_SUCCESS = 'REMOVE_SALE_ITEM_SUCCESS'
export const REMOVE_SALE_ITEM_FAIL = 'REMOVE_SALE_ITEM_FAIL'
